import { render } from "./FileView.vue?vue&type=template&id=7c06f458"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__